class Province {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      provinceId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allProvinces.length; i++) {
          if (this.allProvinces[i].id == 0) {
            return;
          }
        }
        this.allProvinces.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allProvinces;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allProvinces = [];
        this.allProvinces = temp;
        this.getProvinceFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.province = new Province('');
      for (var i = 0; i < this.allProvinces.length; i++) {
        if (this.allProvinces[i].id == id) {
          if (id == 0) {
            this.allProvinces.splice(i, 1);
          }
          this.allProvinces[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addProvinceFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش استان';
        this.$refs.confirm.text = 'از ویرایش استان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف استان';
        this.$refs.confirm.text = 'از حذف استان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addProvinceFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editProvinceFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteProvinceFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.provinceId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
